import axios from 'axios';
import ENV from 'browser-environment';

import Component from '@/scripts/core/Component';
import { toggleClass } from '@/scripts/helpers/utils';

class Catalog extends Component {
  onInit() {
    this.isLoading = false;
    this.isAuto = false;

    this.loadMore = this.loadMore.bind(this);
    this.checkScroll = this.checkScroll.bind(this);

    this.setLoadMoreEvents();
    this.checkScroll();

    window.addEventListener('popstate', () => {
      document.location.reload();
    });
  }

  onDestroy() {
  }

  onUpdateRefs(refs, oldRefs) {
    if (refs.loadMore === oldRefs.loadMore) return;
    this.setLoadMoreEvents();
  }

  setLoadMoreEvents(add = true) {
    if (!this.$refs.loadMore) return;
    const action = add ? 'addEventListener' : 'removeEventListener';
    this.$refs.loadMore[action]('click', this.loadMore);

    const props = this.$getRefProps(this.$refs.loadMore);
    this.isAuto = props && props.auto;

    if (this.isAuto) {
      window[action]('scroll', this.checkScroll);
    }
  }

  setLoadMoreLoadingState(loading) {
    if (!this.$refs.loadMore) return;
    toggleClass(this.$refs.loadMore, '_loading', loading);
  }

  loadMore() {
    if (this.isLoading) return;

    const props = this.$getRefProps(this.$refs.loadMore);

    if (!props || !props.endpoint) {
      console.warn('Missed `endpoint` prop for loadMore ref');
      return;
    }

    if (props.url) {
      window.history.pushState({}, '', props.url);
    }

    this.isLoading = true;
    this.setLoadMoreLoadingState(true);

    axios.get(props.endpoint)
      .then(({ data }) => {
        this.setLoadMoreEvents(false);

        if (this.$refs.pagination) {
          this.$refs.pagination.parentNode.removeChild(this.$refs.pagination);
        }
        this.$refs.body.insertAdjacentHTML('beforeend', data.html);

        this.$emit('onCatalogContentInsertAfter', data.data);
      })
      .catch((err) => {
        // TODO: how to display errors for users?
        console.error(err);
      })
      .finally(() => {
        this.isLoading = false;
        this.setLoadMoreLoadingState(false);
      });
  }

  checkScroll() {
    if (!this.isAuto) return;

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const box = this.$refs.loadMore.getBoundingClientRect();
    const targetScroll = (box.top + scrollTop + box.height - 400) - ENV.viewport.h;

    if (scrollTop >= targetScroll) {
      this.loadMore();
    }
  }
}

export default Catalog;
